import 'scss/services/emotion-analysis.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'

import { config } from 'config'
import { productKesa } from 'js/api/services'
import 'js/libs/gt'

var demoTextList = [
  '我觉得挺感动。她是一个那么坚强的人，独自一个人撑起了整个家庭，非常佩服。',
  '我很喜欢这里，风景如画，空气清新，大家都很友善，这里简直就是个世外桃源。',
  '我在2018年4月份来到了合肥。',
  '我之前所在的学校共有几万名学生。',
  '时至今日，一切都是她咎由自取，自作孽不可活！她缺少对他人的关爱，沉浸在自己的世界里，我不喜欢她!',
  '他阴险狡诈，从不反省自己做下的恶行，是个十恶不赦的大恶魔！'
]
var n = 0

var mnData = [
  {negative_prob: 0.053020241080856824, neutral_prob: 0.061048442125195376, positive_prob: 0.8859313167939478, sentiment: 1},
  {negative_prob: 0.004135800546592159, neutral_prob: 0.4552825233670628, positive_prob: 0.540581676086345, sentiment: 1},
  {negative_prob: 0.003981302769718551, neutral_prob: 0.8347209904392446, positive_prob: 0.16129770679103683, sentiment: 0},
  {negative_prob: 0.1020851677823993, neutral_prob: 0.6187519900284401, positive_prob: 0.2791628421891605, sentiment: 0},
  {negative_prob: 0.6366501539113065, neutral_prob: 0.18943742867171656, positive_prob: 0.1739124174169769, sentiment: 2},
  {negative_prob: 0.6711066780335787, neutral_prob: 0.27150322786123005, positive_prob: 0.05739009410519125, sentiment: 2}
]

var functionalExperienceModel = {
  result: {},
  // 增加极验
  geetestApi1: function () {
    var that = this
    var config = this.config
    $.ajax({
      url: '/herapi/plug/validate?t=' + (new Date()).getTime(),
      type: 'get',
      dataType: 'json',
      success: function (data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captchaObj.onReady(function () {
          }).onSuccess(function () {
            that.result = captchaObj.getValidate()
            if (!that.result) {
              return alert('请完成验证')
            }
            that.analysis()
          })
          // 开始分析
          $('#startLoad').on('click', function () {
            if (that.checkTextarea()) {
              captchaObj.verify()
            }
          })
        })
      }
    })
  },
  analysis: function (isDemo) {
    var that = this
    if (isDemo) {
      that.render(mnData[n])
    } else {
      if (that.checkTextarea()) {
        var params = {
          challenge: that.result.geetest_challenge,
          validate: that.result.geetest_validate,
          seccode: that.result.geetest_seccode,
          text: that.checkTextarea(),
          type: 'sa'
        }
        $.mask()
        productKesa(params).then(function (result) {
          $.mask('hide')
          if (result.flag && result.data) {
            that.render(result.data)
          } else if (result.code === '99999' || result.code === 99999) {
            $.alerts.alert('系统异常，请稍后再试')
          } else if (result.code === '20011' || result.code === 20011) {
            $.alerts.alert('验证码校验不通过')
          }
        })
      }
    }
  },
  render: function (res) {
    var that = this
    var analysisResultTmpl = `<span class="analysis-result">情感分析结果</span>`
    switch (res.sentiment) {
      case 0:
        analysisResultTmpl += `<i class="icons icons-icon icons-icon-neutral"></i>
        <span>中性</span>`
        break
      case 1:
        analysisResultTmpl += `<i class="icons icons-icon icons-icon-positive"></i>
        <span>褒义</span>`
        break
      case -1:
        analysisResultTmpl += `<i class="icons icons-icon icons-icon-negative"></i>
        <span>贬义</span>`
        break
    }
    $('.analysis-wrap').empty().html(analysisResultTmpl)
  },
  // 切换示例文本
  changeDemo: function () {
    if (n >= (demoTextList.length - 1)) {
      n = 0
    } else {
      n += 1
    }
    $('#analysisText').val(demoTextList[n])
    this.analysis(true)
  },
  // 检查文本框输入内容
  checkTextarea: function () {
    var text = $('#analysisText').val().trim()
    var rules = new RegExp(/^[a-zA-Z\d]+$/)

    if (text === '') {
      $.alerts.alert('您没有输入内容')
      return false
    } else if (text.length > 100) {
      $.alerts.alert('最多输入100字')
      return false
    } else if (rules.test(text.replace(/\s/g, ''))) {
      $.alerts.alert('抱歉，仅支持中文内容分析')
      return false
    } else {
      return String(text)
    }
  },
  addEvent: function () {
    var that = this
    // 更换示例
    $(document).on('click', '#changText', function () {
      that.changeDemo()
    })
    // 分词&词性点击效果
    $(document).on('click', '#participleAndPart li', function (e) {
      let $this = $(e.currentTarget)
      let $parent = $this.parent()
      let $parentSiblingsUl = $parent.siblings('ul')
      let code = $this.data('code')
      if (!$this.hasClass('select')) {
        $this.parent().find('li').removeClass('select')
        $this.addClass('select')
        $parentSiblingsUl.find('li').removeClass('select')
        $parentSiblingsUl.find('.' + code).addClass('select')
      }
    })
  },
  init: function () {
    var that = this
    $('#analysisText').val(demoTextList[n])
    that.analysis(true)
    that.geetestApi1()
    that.addEvent()
  }
}

$(function () {
  serviceTopbar()
  functionalExperienceModel.init()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/emotion-analysis.js